import React, {Component} from 'react'
import Typography from 'material-ui/Typography'
import {withStyles, createStyleSheet} from 'material-ui/styles'

const styleSheet = createStyleSheet('Player', theme => ({
    label: {
        marginTop: theme.spacing.unit * 2,
        marginBottom: theme.spacing.unit * 4
    }

}));


class Label extends Component {

    render() {

        if (this.props.content === '') {
            return null
        }
        const classes = this.props.classes
        return (
            <Typography type="title" className={classes.label}>
                <span>{this.props.title}</span>

                <span>{this.props.content}</span>
            </Typography>

        )
    }

}


export default withStyles(styleSheet)(Label)


// WEBPACK FOOTER //
// ./src/label.jsx